// extracted by mini-css-extract-plugin
export var errorsContainer = "_qk-1";
export var link = "_qk-0";